module.exports = __webpack_public_path__ + "img/7-2.1f37757a.png";